import './Footer.css'

const Footer = () => ( <
    footer className = 'footer' >
    <
    a href = 'https://github.com/chandankumarm55'
    className = 'link footer__link' >
    CK <
    /a> < /
    footer >
)

export default Footer